import config from "@/shared/config";

const configModules = import.meta.glob<{ default: Record<string, unknown> }>(
  "@/modules/*/config/index.ts",
  { eager: true }
);

const getModuleConfig = (moduleName: string) => {
  const matchedEntry = Object.entries(configModules).find(([key]) =>
    key.endsWith(`/src/modules/${moduleName}/config/index.ts`)
  );
  return matchedEntry?.[1]?.default || {};
};

const appConfig = {
  install(app: any, options: any) {
    let moduleConfigs = {};

    if ("modules" in options) {
      moduleConfigs = options["modules"].reduce(
        (prev: Record<string, unknown>, module: string) => {
          try {
            const moduleConfig = getModuleConfig(module);

            return {
              ...prev,
              ...moduleConfig,
            };
          } catch (err) {
            console.error(`Error on Load Module  ${module} Config`);
            console.error(err);
            return prev;
          }
        },
        moduleConfigs
      );
    }

    app.provide("config", {
      ...config,
      ...moduleConfigs,
    });

    app.config.globalProperties.$config = {
      ...config,
      ...moduleConfigs,
    };
  },
};

export default appConfig;
